import { isFieldError } from "../utils";
import S from "./styled";

const InputDate = ({
	name,
	label,
	reqd,
	autocomplete = "off",
	update,
	errors,
	visible = true,
	value = "",
	min = "",
	max = "",
}) => {
	return (
		<S.Container className={visible ? `` : `invisible`}>
			<label htmlFor={name}>
				{`${label}`} {reqd ? <span className="error">*</span> : null}
			</label>
			<input
				type="date"
				name={name}
				id={name}
				autoComplete={autocomplete}
				onChange={(e) => update(name, e.target.value)}
				className={isFieldError(errors, name) ? `error` : ``}
				defaultValue={value}
				min={min}
				max={max}
			/>
		</S.Container>
	);
};
export default InputDate;
